 
import components, { typeUnmounted } from 'consts/components';
import {
  baseDomainDetail,
  fetchLoadDomainInGroup,
  fetchLoadDomainInGroupFailed,
  fetchLoadDomainInGroupSuccess,
  fetchLoadDomainGroupSetting,
  fetchSearchDomainCancelled,
  fetchSearchDomainFailed,
  fetchSearchDomainSuccess,
  fetchSearchDomain,
  baseGetAllDomain,
  fetchAllDomain,
  fetchAllDomainSuccess,
  fetchAllDomainFailed,
  fetchLoadMoreAllDomain,
  fetchLoadMoreAllDomainSuccess,
  fetchLoadMoreAllDomainFailed,
  fetchCampaignInDomain,
  fetchCampaignInDomainSuccess,
  fetchCampaignInDomainFailed,
  fetchResponderInDomain,
  fetchResponderInDomainFailed,
  fetchResponderInDomainSuccess,
} from 'redux/handleReducers';
import types from 'redux/types';

const initialState = {
  // state loading
  isCreatingDomainGroup: false,
  isFetchedDomainGroup: false,

  isFetchingDomain: false,
  isFetchedDomain: false,
  isAddingDomain: false,
  isDeletingDomain: false,
  isSearching: false,
  isSearched: false,
  isBuying: false,
  isSetuping: false,
  isUpdating: false,

  // data
  resGetDomain: {},
  resultDomainSearch: [],

  // error
  errorSetup: null,
  errorUpdateDomain: null,
  errorBuyDomain: null,
  errorDeleteDomain: null,
  errorGetDomain: null,
  errorAddDomain: null,
  errorSearchDomain: null,

  errorAddDomainGroup: null,

  ...baseGetAllDomain(),
  ...baseDomainDetail(),

  campaign: {
    isFetching: false,
    isLoadingMore: false,
    data: [],
    error: null,
  },
  responder: {
    isFetching: false,
    isLoadingMore: false,
    data: [],
    error: null,
  },
};

const calculateDeliveryRate = (domains) => {
  domains.result.map((i) => {
    if (typeof i.used_count == undefined || typeof i.failed_count == undefined) {
      i.delivery_rate = '';
      return i;
    }

    if (i.used_count != 0)
      i.delivery_rate = Math.round(((i.used_count - i.failed_count) / i.used_count) * 100) + '%';
    else if (i.used_count == 0) i.delivery_rate = '100%';

    return i;
  });
  return domains;
};

export default (state, actions) => {
  if (!state) {
    return initialState;
  }

  switch (actions.type) {
    case types.REQUEST_GET_RESPONDER_IN_DOMAIN:
      return fetchResponderInDomain(actions, state);

    case types.REQUEST_GET_RESPONDER_IN_DOMAIN_SUCCESS:
      return fetchResponderInDomainSuccess(actions, state);

    case types.REQUEST_GET_RESPONDER_IN_DOMAIN_FAILED:
      return fetchResponderInDomainFailed(actions, state);

    case types.REQUEST_GET_CAMPAIGN_IN_DOMAIN:
      return fetchCampaignInDomain(actions, state);

    case types.REQUEST_GET_CAMPAIGN_IN_DOMAIN_SUCCESS:
      return fetchCampaignInDomainSuccess(actions, state);

    case types.REQUEST_GET_CAMPAIGN_IN_DOMAIN_FAILED:
      return fetchCampaignInDomainFailed(actions, state);

    case types.REQUEST_LOAD_DOMAINS_IN_GROUP:
      return fetchLoadDomainInGroup(actions, state);

    case types.REQUEST_LOAD_DOMAINS_IN_GROUP_SUCCESS:
      return fetchLoadDomainInGroupSuccess(actions, state);

    case types.REQUEST_SAVE_DOMAIN_GROUP_SETTING_SUCCESS:
      return fetchLoadDomainGroupSetting(actions, state);

    case types.REQUEST_LOAD_DOMAINS_IN_GROUP_FAILED:
      return fetchLoadDomainInGroupFailed(actions, state);

    case types.REQUEST_CREATE_DOMAIN_GROUP:
      return {
        ...state,
        isCreatingDomainGroup: true,
      };

    case types.REQUEST_CREATE_DOMAIN_GROUP_SUCCESS: {
      return {
        ...state,
        isCreatingDomainGroup: false,
        errorAddDomainGroup: null,
      };
    }

    case types.REQUEST_CREATE_DOMAIN_GROUP_FAILED:
      return {
        ...state,
        errorAddDomainGroup: actions.error,
        isCreatingDomainGroup: false,
      };

    case types.REQUEST_GET_ALL_DOMAIN_GROUP:
      return fetchAllDomain(actions, state);

    case types.REQUEST_GET_ALL_DOMAIN_GROUP_SUCCESS:
      return fetchAllDomainSuccess(actions, state);

    case types.REQUEST_GET_ALL_DOMAIN_GROUP_FAILED:
      return fetchAllDomainFailed(actions, state);

    case types.REQUEST_LOAD_MORE_ALL_DOMAIN:
      return fetchLoadMoreAllDomain(actions, state);

    case types.REQUEST_LOAD_MORE_ALL_DOMAIN_SUCCESS:
      return fetchLoadMoreAllDomainSuccess(actions, state);

    case types.REQUEST_LOAD_MORE_ALL_DOMAIN_FAILED:
      return fetchLoadMoreAllDomainFailed(actions, state);

    case types.REQUEST_SETUP_DOMAIN:
      return {
        ...state,
        isSetuping: true,
      };

    case types.REQUEST_SETUP_DOMAIN_SUCCESS:
      return {
        ...state,
        isSetuping: false,
        errorSetup: null,
      };

    case types.REQUEST_SETUP_DOMAIN_FAILED:
      return {
        ...state,
        errorSetup: actions.error,
        isSetuping: false,
      };

    case types.REQUEST_UPDATE_ALL_DOMAIN:
    case types.REQUEST_UPDATE_DOMAIN:
      return {
        ...state,
        isUpdating: true,
      };

    case types.REQUEST_UPDATE_ALL_DOMAIN_SUCCESS:
    case types.REQUEST_UPDATE_DOMAIN_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        errorUpdateDomain: null,
      };

    case types.REQUEST_UPDATE_ALL_DOMAIN_FAILED:
    case types.REQUEST_UPDATE_DOMAIN_FAILED:
      return {
        ...state,
        errorUpdateDomain: actions.error,
        isUpdating: false,
      };

    case types.REQUEST_CLEAR_DATA_SEARCH_DOMAIN: {
      return {
        ...state,
        isSearching: false,
        isSearched: false,
      };
    }

    case types.REQUEST_BUY_DOMAIN:
      return {
        ...state,
        isBuying: true,
      };

    case types.REQUEST_BUY_DOMAIN_SUCCESS:
      return {
        ...state,
        isBuying: false,
        errorBuyDomain: null,
      };

    case types.REQUEST_BUY_DOMAIN_FAILED:
      return {
        ...state,
        errorBuyDomain: actions.error,
        isBuying: false,
      };

    case types.REQUEST_SEARCH_DOMAIN:
      return fetchSearchDomain(actions, state);

    case types.REQUEST_SEARCH_DOMAIN_SUCCESS:
      return fetchSearchDomainSuccess(actions, state);

    case types.REQUEST_SEARCH_DOMAIN_FAILED:
      return fetchSearchDomainFailed(actions, state);

    case types.REQUEST_SEARCH_DOMAIN_CANCELLED:
      return fetchSearchDomainCancelled(actions, state);

    case types.REQUEST_DELETE_DOMAIN:
      return {
        ...state,
        isDeletingDomain: true,
      };

    case types.REQUEST_DELETE_DOMAIN_SUCCESS:
      return {
        ...state,
        isDeletingDomain: false,
      };

    case types.REQUEST_DELETE_DOMAIN_FAILED:
      return {
        ...state,
        errorDeleteDomain: actions.error,
        isDeletingDomain: false,
      };

    case types.REQUEST_ADD_DOMAIN:
      return {
        ...state,
        isAddingDomain: true,
      };

    case types.REQUEST_ADD_DOMAIN_SUCCESS:
      return {
        ...state,
        isAddingDomain: false,
      };

    case types.REQUEST_ADD_DOMAIN_FAILED:
      return {
        ...state,
        errorAddDomain: actions.error,
        isAddingDomain: false,
      };

    case types.REQUEST_GET_DOMAIN:
      return {
        ...state,
        isFetchingDomain: true,
        isFetchedDomain: false,
      };

    case types.REQUEST_GET_DOMAIN_SUCCESS:
      return {
        ...state,
        isFetchingDomain: false,
        isFetchedDomain: true,
        resGetDomain: calculateDeliveryRate(actions.data),
        errorGetDomain: null,
      };

    case types.REQUEST_GET_DOMAIN_FAILED:
      return {
        ...state,
        errorGetDomain: actions.error,
        isFetchingDomain: false,
        isFetchedDomain: true,
      };

    case typeUnmounted(components.domainDetail):
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
